import {initProductSlider} from "./product-slider";

const productRecommendationsSection = document.querySelector('.js-product-recommendations');

const handleIntersection = (entries, observer) => {

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.js-product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }

            [...document.querySelectorAll('.js-product-slider')].forEach((element) => {
                initProductSlider(element, 1.25);
            });
        })
        .catch(e => {
            console.error(e);
        });
};

const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px 200px 0px'
});

if(productRecommendationsSection) {
    observer.observe(productRecommendationsSection);
}
